module.exports = __webpack_public_path__ + "img/across front.afe06db1.png";